(function () {
  // =========================================
  // JustNatural - Banner Tracking (GTM Option A)
  //
  // Sends events to GTM via dataLayer ONLY.
  // (This avoids the issue where gtag routes events to Google Ads AW-... instead of GA4.)
  //
  // Tracks:
  //   - banner_impression (when banner is visible)
  //   - banner_click (when banner is clicked)
  //
  // Requires banner elements to have:
  //   class="js-jn-banner"
  //   data-banner-id, data-banner-type, data-brand, data-placement, data-creative (optional)
  // =========================================

  var SELECTOR = ".js-jn-banner";
  var IMPRESSION_THRESHOLD = 0.5; // 50% visible counts as an impression
  var DEBUG = false; // set true temporarily for console logs

  // Dedupe: impressions should fire once per element per page load
  var impressionFired = new WeakSet();

  function log() {
    if (!DEBUG) return;
    // eslint-disable-next-line no-console
    console.log.apply(console, arguments);
  }

  function getPayload(el) {
    var d = (el && el.dataset) ? el.dataset : {};
    return {
      banner_id: d.bannerId || "unknown",
      banner_type: d.bannerType || "unknown",
      brand: d.brand || "unknown",
      placement: d.placement || "unknown",
      creative: d.creative || ""
    };
  }

  function sendEvent(eventName, payload) {
    // Option A: Always push to dataLayer (GTM will forward to GA4)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    log("[JN Banner Tracking] dataLayer.push:", eventName, payload);
  }

  // -----------------------------------------
  // Impressions
  // -----------------------------------------
  var observer = null;

  function observeBanner(el) {
    if (!el || impressionFired.has(el)) return;
    if (observer) observer.observe(el);
  }

  function setupIntersectionObserver() {
    var banners = document.querySelectorAll(SELECTOR);

    if (!banners.length) {
      log("[JN Banner Tracking] No banners found for impressions.");
      return;
    }

    if (!("IntersectionObserver" in window)) {
      log("[JN Banner Tracking] IntersectionObserver not supported; fallback to immediate impressions.");
      banners.forEach(function (el) {
        if (impressionFired.has(el)) return;
        impressionFired.add(el);
        sendEvent("banner_impression", getPayload(el));
      });
      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          if (impressionFired.has(el)) return;

          impressionFired.add(el);
          sendEvent("banner_impression", getPayload(el));

          // Stop observing once counted
          observer.unobserve(el);
        });
      },
      { threshold: IMPRESSION_THRESHOLD }
    );

    banners.forEach(observeBanner);

    log("[JN Banner Tracking] Observer attached to banners:", banners.length);
  }

  // If a slider rotates, we want impressions on newly active slides too.
  // Dawn/Shopify sliders often toggle aria-hidden; we can watch for that and re-scan.
  function setupSlideChangeWatcher() {
    document.addEventListener("slide-changed", onPossibleNewBanner);
    document.addEventListener("slideshow:changed", onPossibleNewBanner);

    var mo = new MutationObserver(function (mutations) {
      var shouldRescan = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.addedNodes && m.addedNodes.length) {
          shouldRescan = true;
          break;
        }

        if (
          m.type === "attributes" &&
          (m.attributeName === "class" || m.attributeName === "aria-hidden" || m.attributeName === "style")
        ) {
          shouldRescan = true;
          break;
        }
      }

      if (shouldRescan) onPossibleNewBanner();
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-hidden", "style"]
    });

    log("[JN Banner Tracking] Slide change watcher enabled.");
  }

  var rescanScheduled = false;
  function onPossibleNewBanner() {
    if (rescanScheduled) return;
    rescanScheduled = true;

    window.setTimeout(function () {
      rescanScheduled = false;

      document.querySelectorAll(SELECTOR).forEach(function (el) {
        if (!impressionFired.has(el)) observeBanner(el);
      });
    }, 200);
  }

  // -----------------------------------------
  // Clicks (delegated)
  // -----------------------------------------
  function setupClickTracking() {
    document.addEventListener(
      "click",
      function (e) {
        var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
        if (!el) return;

        // Only primary button clicks
        if (typeof e.button === "number" && e.button !== 0) return;

        sendEvent("banner_click", getPayload(el));
      },
      true
    );

    log("[JN Banner Tracking] Click tracking attached.");
  }

  // -----------------------------------------
  // Init
  // -----------------------------------------
  function init() {
    setupIntersectionObserver();
    setupSlideChangeWatcher();
    setupClickTracking();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
